import React, { useState, useMemo } from "react";
import DataTable from "react-data-table-component";
import { Button, Modal } from "react-bootstrap";
import { customStyles } from "../../utils/data/essential";
import CreateAgent from "../../Component/agents/CreateAgent";
import DisplayAgent from "../../Component/agents/DisplayAgent";
import UpdateAgent from "../../Component/agents/UpdateAgent";
import AssignAgentLocation from "../../Component/agents/AssignAgentLocation";
import { useFetchData } from "../../hooks/useFetchData";
import { editAgent } from "../../utils/roles";
import { agentColumns } from "../../utils/columns/agentColumns";
const Agents = () => {
  const [showCreateAgentModal, setShowCreateAgentModal] = useState(false);
  const [subscriberData, setSubscriberData] = useState([]);
  const [showSubscriberModal, setShowSubscriberModal] = useState(false);
  const [row, setRow] = useState();
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [agentId, setAgentId] = useState();
  const [agentStatusModal, setagentStatusModal] = useState(false);
  const [keyword, setKeyword] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));
  const roles = JSON.parse(localStorage.getItem("roles"));
  // Fetch agents
  const location = JSON.parse(localStorage.getItem("locations"));
  const locationId = location[location.length - 1].id;
  const url = `agents?locationId=${locationId}`;
  const { data, isLoading } = useFetchData(["fetch-agents"], url,true,user);
  const filterData = (searchTerm) => {
     if (!searchTerm) {
       return data;
     }
     return data?.filter((dt) => {
       return (
         dt?.subscriber?.firstName
           ?.toLowerCase()
           .includes(searchTerm.toLowerCase()) ||
         dt?.subscriber?.lastName
           ?.toLowerCase()
           .includes(searchTerm.toLowerCase()) ||
         dt?.subscriber?.phoneNumber?.toLowerCase().includes(searchTerm)
       );
     });
  };
  const filteredData = useMemo(() => filterData(keyword), [data, keyword]);

  if (isLoading)
    return (
      <div
        className='d-flex justify-content-center'
        style={{ marginTop: "15%" }}
      >
        <h5>Loading...</h5>
      </div>
    );
  const handleShowModal = (type) => {
    if (type === "create") {
      setShowCreateAgentModal(true);
    } else if (type === "display") {
      setShowSubscriberModal(true);
    } else {
      setagentStatusModal(true);
    }
  };
  const handleCloseModal = (type) => {
    if (type === "create") {
      setShowCreateAgentModal(false);
    } else if (type === "display") {
      setShowSubscriberModal(false);
    } else {
      setagentStatusModal(false);
    }
  };
  const columns = agentColumns(
    roles,
    setShowLocationModal,
    setAgentId,
    setRow,
    handleShowModal
  );
  return (
    <div>
      {roles?.some((role) => role.id === editAgent) && (
        <div className='d-flex justify-content-end mr-3'>
          <Button
            onClick={() => handleShowModal("create")}
            className='custom-btn-color'
          >
            <i className='fa fa-plus' />
            &nbsp; Create Agent
          </Button>
        </div>
      )}
      {data?.length > 0 && (
        <div className='flex-container'>
          <div className='quick-search-container'>
            <input
              type='text'
              className='form-control quick-search ml-2'
              placeholder="Quick search by agent's names or phone number"
              onChange={(e) => {
                setKeyword(e.target.value);
              }}
              style={{ bottom: !roles?.some((role) => role.id === editAgent) ? -60:0 }}
            />
          </div>
        </div>
      )}
      <div className='table-responsive datatables dataValidation-Wrap thead-primary pr-3 pl-3 mr-2'
        style={{ marginTop: !roles?.some((role) => role.id === editAgent) ? 70:'' }}
      >
        <DataTable
          columns={columns}
          data={filteredData}
          responsive={true}
          customStyles={customStyles}
          pagination
          highlightOnHover
          striped
          noHeader
        />
      </div>

      {/* Show agent details */}
      <DisplayAgent
        agent={subscriberData}
        show={showSubscriberModal}
        hide={() => handleCloseModal("display")}
      />
      {/* Create Agent Modal */}
      <CreateAgent
        show={showCreateAgentModal}
        hide={() => handleCloseModal("create")}
      />
      {/* Update account status */}
      <UpdateAgent
        agentStatus={row}
        show={agentStatusModal}
        hide={() => handleCloseModal("update")}
      />
      {/* Assign location to the agent */}
      <Modal
        size='md'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={showLocationModal}
      >
        <Modal.Header closeButton onClick={() => setShowLocationModal(false)}>
          <h5> Add Location to Agent</h5>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f0f0fa" }}>
          <AssignAgentLocation
            agentId={agentId}
            setStep={() => {}}
            hide={() => setShowLocationModal(false)}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Agents;
